import { COLOR } from 'vars/index'

export const IconPositions = {
  Left: 'Left',
  Right: 'Right',
} as const
export type IconPositions = (typeof IconPositions)[keyof typeof IconPositions]

export const IconSizes = {
  small: 'small',
  medium: 'medium',
} as const
export type IconSizes = (typeof IconSizes)[keyof typeof IconSizes]

export const ButtonFonts = {
  Button1: 'Button1',
  Button2: 'Button2',
} as const
export type ButtonFonts = (typeof ButtonFonts)[keyof typeof ButtonFonts]

export const ButtonCorners = {
  CORNERS_0: 'CORNERS_0',
  CORNERS_20: 'CORNERS_20',
  CORNERS_30: 'CORNERS_30',
  CORNERS_50: 'CORNERS_50',
} as const
export type ButtonCorners = (typeof ButtonCorners)[keyof typeof ButtonCorners]

export const ButtonBordersWidth = {
  BORDER_0: 'BORDER_0',
  BORDER_10: 'BORDER_10',
  BORDER_20: 'BORDER_20',
  BORDER_30: 'BORDER_30',
} as const
export type ButtonBordersWidth =
  (typeof ButtonBordersWidth)[keyof typeof ButtonBordersWidth]

export const ButtonBorderColors = {
  COLOR_ACCENT_TERTIARY: COLOR.ACCENT_TERTIARY,
  COLOR_ACCENT_SECONDARY: COLOR.ACCENT_SECONDARY,
  COLOR_ACCENT_PRIMARY_PRESSED: COLOR.ACCENT_PRIMARY_PRESSED,
  COLOR_ACCENT_DISABLED: COLOR.DISABLED,
  COLOR_BASE_DEFAULT: COLOR.BASE_MAIN_DEFAULT,
  SURFACE_LIGHT_2: COLOR.SURFACE_LIGHT_2,
  COLOR_BASE_PRESSED: COLOR.BASE_MAIN_PRESSED,
  COLOR_DISABLED: COLOR.DISABLED,
} as const
export type ButtonBorderColors =
  (typeof ButtonBorderColors)[keyof typeof ButtonBorderColors]

export const ActionButtonColors = {
  TEXT_ICON_CONSTANT_LIGHT: COLOR.TEXT_ICON_CONSTANT_LIGHT,
  TEXT_ICON_CONSTANT_DARK: COLOR.TEXT_ICON_CONSTANT_DARK,
  TEXT_ICON_TERTIARY: COLOR.TEXT_ICON_TERTIARY,
  COLOR_MAIN_DEFAULT: COLOR.BASE_MAIN_DEFAULT,
  SURFACE_LIGHT_2: COLOR.SURFACE_LIGHT_2,
  COLOR_MAIN_PRESSED: COLOR.BASE_MAIN_PRESSED,
  COLOR_TEXT_SECONDARY: COLOR.TEXT_ICON_SECONDARY,
} as const
export type ActionButtonColors =
  (typeof ActionButtonColors)[keyof typeof ActionButtonColors]

export const ButtonFluid = {
  Vertical: 'vertical',
  Horizontal: 'horizontal',
  Both: 'both',
  None: 'none',
} as const
export type ButtonFluid = (typeof ButtonFluid)[keyof typeof ButtonFluid]
